import cmsTitle from "@/components/Title.vue" // 首页标题
import mediaTitle from "@/components/mediaTitle.vue" // 媒体视听标题
import cmsNews from "@/components/List.vue" // 新闻列表
import cmsBreadcrumb from "@/components/Breadcrumb.vue" // 面包屑
import cmsDownload from "@/components/Download.vue" // 下载
import relevantNews from "@/components/RelevantNews.vue" // 相关新闻
import cmsVideo from "@/components/Video.vue" // 视频video
import cmsVideo1 from "@/components/Video1.vue" // 视频video
import webTopping from "@/components/Topping.vue" // 置顶

// 这里是重点
const cmsComponents = {
  install: function(Vue) {
    Vue.component('cmsTitle', cmsTitle)
    Vue.component('cmsMediaTitle', mediaTitle)
    Vue.component('cmsNews', cmsNews)
    Vue.component('cmsBreadcrumb', cmsBreadcrumb)
    Vue.component('cmsDownload', cmsDownload)
    Vue.component('relevantNews', relevantNews)
    Vue.component('cmsVideo', cmsVideo)
    Vue.component('cmsVideo1', cmsVideo1)
    Vue.component('webTopping', webTopping)
  }
}

// 导出组件
export default cmsComponents



// WEBPACK FOOTER //
// ./src/components/index.js